/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrChildContentModule } from "igniteui-react-core";
import { IgrInput } from './igr-input';
import { Input } from './Input';
import { TypeRegistrar } from "igniteui-react-core";
var IgrInputModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrInputModule() {
    }
    IgrInputModule.register = function () {
        IgrChildContentModule.register();
        TypeRegistrar.registerCons('IgrInput', IgrInput);
        TypeRegistrar.registerCons('IgrInput', IgrInput);
        TypeRegistrar.register('Input', Input.$type);
    };
    return IgrInputModule;
}());
export { IgrInputModule };
//# sourceMappingURL=igr-input-module.js.map
